import { useMediaQuery } from 'react-responsive';
import PcHeader from '@/components/pc/Header';
import MobileHeader from '@/components/mo/Header';

const Header = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return isMobile ? <MobileHeader /> : <PcHeader />;
};

export default Header;
